import { createFileRoute, redirect } from '@tanstack/react-router';

/** `/a` has no page of its own: it opens the restaurant list. */
export const Route = createFileRoute('/a/')({
  beforeLoad: () => {
    throw redirect({ to: '/a/restaurants' });
  },
});
